import React from 'react'
import { Card, CardContent, Grid, Avatar, Button } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import head from 'img/016.png'
import kbank from 'img/017.png'
import ktb from 'img/018.png'
import bay from 'img/019.png'
import bbl from 'img/020.png'
import scb from 'img/021.png'
import ttb from 'img/022.png'
import gsb from 'img/023.png'
import cimb from 'img/024.png'
import tcr from 'img/025.png'
import lhb from 'img/026.png'
import ghb from 'img/027.png'
import baac from 'img/028.png'
import uob from 'img/029.png'
import citi from 'img/030.png'
import kkp from 'img/031.png'
import tcb from 'img/032.png'

import footer from 'img/039.png'
import mobilefooter from 'img/040.png'

const First = ({setPage}) => {
    return ( 
        <Card style={{backgroundColor: "#19459D"}}>
            <CardContent>
            <div className='d-flex justify-content-center'>
                    <img src={head} width='460vw' />
               </div>
                <Card style={{backgroundColor: "#E6E7E8", borderBottomLeftRadius: 0, borderBottomRightRadius: 0}}>
                <CardContent>
                <div className='container'>
                    <div className='row'><Avatar sx={{ bgcolor: '#FEC33B', color:'#19459D', marginRight: 3, fontSize: 30 }}>1</Avatar><p className='pt-1' style={{fontSize: 25, color: '#19459D'}}>แจ้งธนาคารที่ทำธุรกรรม</p></div>
                    <h6 style={{color: "#19459D", fontSize: 20, marginLeft: window.innerWidth * 0.06}}><FiberManualRecordIcon fontSize="small" /> ธนาคารรับแจ้ง/ตรวจสอบยืนยันความเป็นเจ้าของบัญชีของผู้เสียหาย เพื่อรับ Case ID ผ่านทาง SMS</h6>
                    <h6 style={{color: "#19459D", fontSize: 20, marginLeft: window.innerWidth * 0.06}}><FiberManualRecordIcon fontSize="small" /> อายัดบัญชีผู้ต้องสงสัยเบื้องต้น 72 ชั่วโมง</h6>
                    <h6 style={{color: "#19459D", fontSize: 20, marginLeft: window.innerWidth * 0.06}}><FiberManualRecordIcon fontSize="small" /> ประสานงานธนาคารปลายทาง เพื่ออายัดบัญชีรับโอน</h6>
                    <h6 style={{color: "#19459D", fontSize: 20, marginLeft: window.innerWidth * 0.06}}><FiberManualRecordIcon fontSize="small" /> นำส่งเอกสารหลักฐานต่างๆ ให้ธนาคาร</h6>
                    <Grid container className='justify-content-center'>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={kbank} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={ktb} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={bay} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={bbl} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={scb} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={ttb} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={gsb} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={cimb} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={tcr} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={lhb} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={ghb} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={baac} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={uob} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={citi} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={kkp} />
                        </Grid>
                        <Grid item lg={2} md={3} xs={10}>
                            <img src={tcb} />
                        </Grid>
                    </Grid>
                </div>
                <div className='container mt-5'>
                    <div className='row'><Avatar sx={{ bgcolor: '#FEC33B', color:'#19459D', marginRight: 3, fontSize: 30 }}>2</Avatar><p className='pt-1' style={{fontSize: 25, color: '#19459D'}}>แจ้งตำรวจ</p></div>
                    <h6 style={{color: "#19459D", fontSize: 20, marginLeft: window.innerWidth * 0.06}}><FiberManualRecordIcon fontSize="small" /> แจ้งตำรวจหรือแจ้งความออนไลน์ ภายใน 72 ชั่วโมง</h6>
                    <h6 style={{color: "#19459D",fontSize: 20, marginLeft: window.innerWidth * 0.06}}><FiberManualRecordIcon fontSize="small" /> เจ้าหน้าที่ตำรวจพิจารณารับแจ้ง</h6>
                    <h6 style={{color: "#19459D",fontSize: 20, marginLeft: window.innerWidth * 0.06}}><FiberManualRecordIcon fontSize="small" /> ออกเอกสาร และ/หรือ ดำเนินการตามขั้นตอนต่อไป</h6>
                    <h6 style={{color: "#19459D",fontSize: 20, marginLeft: window.innerWidth * 0.06}}><FiberManualRecordIcon fontSize="small" /> แจ้งความออนไลน์สำนักงานตำรวจแห่งชาติ https://thaipoliceonline.go.th/</h6>
                    <h6 style={{color: "#19459D",fontSize: 20, marginLeft: window.innerWidth * 0.06}}><FiberManualRecordIcon fontSize="small" /> แจ้งความที่สถานีตำรวจใกล้บ้าน</h6>
                </div>
                <div className='container text-center mt-5'>
                    <h5 style={{color: "#19459D"}}>โปรดระมัดระวัง อย่าหลงเชื่อ ไม่คลิก ไม่กด ไม่ส่งข้อมูล&nbsp;
                    {window.innerWidth > 800 && (
                        <br />
                    )}
                    ไม่ติดต่อกับบุคคลที่ไม่รู้จัก หรือไม่สามารถยืนยันตัวตนว่า
                    {window.innerWidth > 800 && (
                        <br />
                    )}
                    เป็นเจ้าหน้าที่ กบข. โดยเด็ดขาด</h5>
                </div>

            </CardContent>
                </Card>
                <Card style={{backgroundColor: "#E6E7E8", borderTopLeftRadius: 0, borderTopRightRadius: 0}}>
                    <img src={window.innerWidth > 900 ? footer : mobilefooter} width='100%' />
                </Card>
            </CardContent>
        </Card>
     );
}
 
export default First;